export default __webpack_public_path__ + "static/media/delIcon.4e16144a.svg";